import React from "react";
import { TextField } from "@mui/material";
import "./Textfield.scss";

const Textfield = (props) => {
  const {
    id,
    name,
    label,
    type,
    variant,
    value,
    handleOnChange: onChange,
    onBlur,
    error,
    helperText,
    autoComplete,
    disabled,
  } = props;
  const fieldProps = {
    id,
    name,
    label,
    type,
    variant,
    value,
    onChange,
    error,
    helperText,
    onBlur,
    disabled,
    autoComplete,
    className: "custom-textfield",
  };
  return <TextField {...fieldProps} />;
};

export default Textfield;
